window.addEventListener('scroll', function () {
  const customProductContainer = document.querySelector('.custom_product__container');
  const header = document.querySelector('.section-header');
  if (customProductContainer.getBoundingClientRect().bottom < 0 || window.scrollY ===  0) {
    header.classList.remove('lock-header');
  }
  else {
    header.classList.add('lock-header');
  }
});
function openWaitListModal(waitingListModalId){
  const waitingListModal = document.getElementById(waitingListModalId);
  waitingListModal.classList.add('open')
}


window.addEventListener('load', function () {
  const selectorDefault = document.getElementById('payment-default');
  const selectorPrime = document.getElementById('payment-prime');
  const waitlistButtonsWrapper = document.querySelector('.waitlist-buttons-wrapper');
  const waitlistPrimeContainer = document.querySelector('.waitlist-prime-container');
  const waitlistRememberButton = document.querySelector('.waitlist-buttons-wrapper .remember');
  const waitingListModalId = document.querySelector('.waitlist-buttons-wrapper .remember')?.dataset?.modalId;
  const waitingListModal = document.getElementById(waitingListModalId);
  const buyButton = document.querySelector(`.ProductSubmitButton-Main`);
  const addToCartCopy = document.querySelector('#add-to-cart-copy');
  const paymentPrime = document.getElementById('payment-method-prime');
  const paymentDefault = document.getElementById('payment-method-default');
  const paymentDefaultBox = document.getElementById('payment-default');
  const paymentPrimeBox = document.getElementById('payment-prime');
  const primeImageVariant = document.getElementById('primeImageVariant');
  const defaultImageVariant = document.getElementById('defaultImageVariant');
  function updatePrimeButtonContent() {
    if (addToCartCopy != null) {
      if (paymentPrime.checked) {
        paymentDefaultBox.classList.add('unselected-method')
        paymentPrimeBox.classList.remove("unselected-method")
        addToCartCopy.innerHTML = 'Assine e economize';
        buyButton.style.background = 'linear-gradient(90deg, #F1D98A 0%, #DCA119 100%)';
        buyButton.style.color = '#260F0F';
        waitlistButtonsWrapper?.classList?.add('hidden');
        waitlistPrimeContainer?.classList?.remove('hidden');
      } else {
        paymentDefaultBox.classList.remove('unselected-method')
        paymentPrimeBox.classList.add("unselected-method")
        addToCartCopy.innerHTML = 'Adicionar ao carrinho';
        buyButton.style.background = '#260F0F';
        buyButton.style.color = '#FFFFFF';
        waitlistButtonsWrapper?.classList?.remove('hidden');
        waitlistPrimeContainer?.classList?.add('hidden');
      }
    }
  }

  waitlistRememberButton?.addEventListener('click', function () {
    waitingListModal?.classList?.add('open');
  });

  if (selectorDefault != null) {
    selectorDefault.addEventListener('click', () => {
      primeImageVariant.classList.add('hidden')
      defaultImageVariant.classList.remove('hidden')
      if (paymentDefault != null) {
        paymentDefault.click();
      }
      updatePrimeButtonContent();
    });
  }

  if (selectorPrime != null) {
    selectorPrime.addEventListener('click', () => {
      primeImageVariant.classList.remove('hidden')
      defaultImageVariant.classList.add('hidden')
      if (paymentPrime != null) {
        paymentPrime.click();
      }
      updatePrimeButtonContent();
    });
  }
});

const caffeineHydrogenUrl = 'https://app.caffeinearmy.com.br/';
let selectedProductHandle = null;
const mountAndRedirectURL = (e, productHandle) => {
  e.preventDefault();
  if (this.selectedProductHandle == null) {
    this.selectedProductHandle = productHandle;
  }
  if (this.selectedProductHandle != null) {
    const formatedProductHandle = `${this.selectedProductHandle}`
      .replace('supercoffee-', '')
      .replaceAll('-', '_')
      .replace('_size', '')
    const stringUrl = `/assinatura/checkout?${formatedProductHandle}=1&plan=Anual`;
    window.location.href = `${caffeineHydrogenUrl}${stringUrl}`;
  }
}

function selectFormat(formatHandle, flavor, blockId, variantId, productId) {
  const allFormats = document.querySelectorAll(`.format-card-carousel--${flavor}`);
  const currentFormat = document.getElementById(`item-${formatHandle}`);
  this.selectedProductHandle = formatHandle;
  const variantInput = document.getElementById(`input-variant--${blockId}`);
  const productIdInput = document.getElementById(`input-product-id--${blockId}`);
  if (variantInput != null && productIdInput != null) {
    variantInput.value = variantId;
    productIdInput.value = productId;
  }

  if (allFormats != null && allFormats.length) {
    allFormats.forEach((format) => {
      format.classList.remove('format-item-carousel-active');
    });
  }
  if (currentFormat != null) {
    currentFormat.classList.add('format-item-carousel-active');
  }

  // Handle quantity for PPB
  const quantityInput = document.getElementById(`Quantity-${blockId}`);
  if (formatHandle.includes('rtd')) {
    if (quantityInput != null) {
      quantityInput.value = 3;
    }
  } else {
    if (quantityInput != null) {
      quantityInput.value = 1;
    }
  }
}
function nutriTableChange(productInfo){
  const nutriTable = document.querySelector('.nutri-table-body');
  let fullNutriTable = '';
  for (let key in productInfo.nutritional_table.valores_tabela) {
    const valor = productInfo.nutritional_table.valores_tabela[key];

    fullNutriTable += `
    <div class="nutri-table-body-content">
      <div>
        <p>${valor.item}</p>
        <p>${valor.value}</p>
      </div>
      <p>${valor.vd}</p>
    </div>
    `;
  }
  nutriTable.innerHTML = fullNutriTable;
  const ingredientList = document.getElementById('productIngredientList');
  ingredientList.innerHTML = productInfo.nutritional_table.ingredients;
  const productBreadCrumb= document.querySelector('.product-page-breadcrumb  > :last-child');
  productBreadCrumb.innerHTML = `
     <a href="${productInfo.url}">${productInfo.stripped_title}</a>
  `;
}


function setPPBQuantity(quantity) {
  const quantityInput = document.querySelector('.quantity__input-ppb');
  if (quantityInput != null) {
    quantityInput.value = quantity;
  }

  const allQuantityButtons = document.querySelectorAll('.quantity__button-ppb');
  if (allQuantityButtons != null && allQuantityButtons.length > 0) {
    allQuantityButtons.forEach((button) => {
      if (button.id === `item-ppb_${quantity}`) {
        button.classList.add('format_active');
      } else {
        button.classList.remove('format_active');
      }
    });
  }
}

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.input.min = min;

        if (max) {
          this.input.max = max;
        } else {
          this.input.removeAttribute('max');
        }
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        // this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner')?.classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

function setPreLaunch(isPrimeExclusive){
  const paymentBox = document.querySelector('.payment-method-box')
  const buyContainer = document.querySelector('.quantity_buy__container')
  const preLaunchButton = document.querySelector('.pre-launch-button')
  const paymentDefault = document.getElementById('payment-default');
  const paymentPrime = document.getElementById('payment-method-prime');
  const buyButton = document.querySelector(`.ProductSubmitButton-Main`);
  const addToCartCopy = document.querySelector('#add-to-cart-copy');
  if(paymentBox &&  buyContainer ) {
    if(isPrimeExclusive){
      paymentDefault.classList.add('hidden-block')
      paymentPrime.click()
      addToCartCopy.innerHTML = 'Assine e economize';
      buyButton.style.background = 'linear-gradient(90deg, #F1D98A 0%, #DCA119 100%)';
      buyButton.style.color = '#260F0F';
    }else{
      paymentBox.classList.add('hidden-block')
      buyContainer.classList.add('hidden-block')
    }
  }
  if(preLaunchButton) preLaunchButton.classList.remove('hidden-block')
}
function setDefaultProduct(){
  const paymentBox = document.querySelector('.payment-method-box')
  const buyContainer = document.querySelector('.quantity_buy__container')
  const preLaunchButton = document.querySelector('.pre-launch-button')
  const paymentDefault = document.getElementById('payment-default');
  if(paymentBox &&  buyContainer ) {
    paymentDefault.classList.remove('hidden-block')
    paymentBox.classList.remove('hidden-block')
    buyContainer.classList.remove('hidden-block')
  }
  if(preLaunchButton) preLaunchButton.classList.add('hidden-block')
}

function defineFlavor(productData){
  window.scrollTo(0, 0);
  const productInfo = JSON.parse(productData);

  if(productInfo.is_pre_launch == 'true'){
     setPreLaunch(productInfo.is_prime_exclusive)
  }else{
    setDefaultProduct()
  }

  const inputVariant = document.getElementById('selectedProductVariantId')
  if(inputVariant)  inputVariant.value = productInfo.variant_id;

  const inputHandle = document.getElementById('selectedHandle')
  if(inputHandle)inputHandle.value = productInfo.handle;

  const mainImage = document.querySelectorAll('.mainProductImage')
  const mainImagePrime = document.querySelector('.mainProductImagePrime');
  mainImage.forEach((image) => {
      image.srcset = productInfo.image;
      image.src = productInfo.image;
    });
  mainImagePrime.src =  productInfo.image_prime
  mainImagePrime.srcset =  productInfo.image_prime
  const flavors= document.querySelectorAll('.flavor-select-box')
  flavors.forEach(flavor => flavor.classList.remove('flavor_active'))

  const currentFlavor = document.querySelector(`.flavor--${productInfo.handle}`)
  currentFlavor.classList.add('flavor_active')

  const backgrounds = document.querySelectorAll('.bg-alt-forced')
  backgrounds.forEach((background) => {
      background.style.background = productInfo.cor_background;
  });

  const mainProductTitle = document.querySelectorAll('.mainProductTitle')
  mainProductTitle.forEach((title) => {
    title.innerHTML = productInfo.title;
  });

  const mainProductDescription = document.querySelector('.custom_product__description');
  mainProductDescription.innerHTML = productInfo.description;

  const prices = document.querySelectorAll('.mainProductPriceItem');
  const discountValue = document.querySelector('.discount-flat-price');
  prices.forEach((price) => {
    price.innerHTML = formatCurrency(productInfo.price);
  });
  discountValue.innerHTML = formatCurrency(productInfo.price - productInfo.flat_discount * 100);

  const discountInfo = document.querySelector('.discount-pix-chip')
  discountInfo.innerHTML = `-${Math.floor(productInfo.prime_discount)}% OFF`

  const bottomImagesGrid = document.querySelector('.bottom-images-grid');
  bottomImagesGrid.innerHTML = productInfo.innerHTML = `
                <div class="item1-bottom"> <img src='${productInfo.media.at(0).src}' alt="product" fetchpriority="high" loading="eager"></div>
                <div class="item2-bottom"> <img src='${productInfo.media.at(1).src}'  alt="product" fetchpriority="high" loading="eager"></div>
                <div class="item3-bottom"> <img src='${productInfo.media.at(2).src}'  alt="product" fetchpriority="high" loading="eager"></div>
  `
  const defaultPayment = document.getElementById('payment-default');
  const primePayment = document.getElementById('payment-method-prime');
  if(productInfo.is_prime_exclusive == 'true'){
    defaultPayment.classList.add('hidden-important');
    primePayment.click();
  }else{
    defaultPayment.classList.remove('hidden-important');
    productInfo.prime_selected === "true" ? primePayment.click() : defaultPayment.click();
  }
  nutriTableChange(productInfo);
  const miniBannerContainer = document.getElementById('mini-banner-product-box');
  miniBannerContainer.innerHTML = productInfo.mini_banner ? `
    <img
      id="mini-banner-product"
      src="${productInfo.mini_banner}"
      width="auto"
      height="auto"
      alt="mini banner produto"
    >
  `: '';
}